import format from "./u-license-plate.js";

window.app = window.app || {};
window.app.form = window.app.form || {};
window.app.form.licenseplate = function(element) {
  element.addEventListener('blur', event => {
    event.target.value = format(event.target.value);
  });
};